module.exports = __webpack_public_path__ + "static/media/11.4a4dd5b4.jpg";